import { render, staticRenderFns } from "./RateHeaderEdit.vue?vue&type=template&id=be68a000&scoped=true&"
import script from "./RateHeaderEdit.vue?vue&type=script&lang=js&"
export * from "./RateHeaderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be68a000",
  null
  
)

export default component.exports